import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import GROUP_CHATTING_ICON from '@/assets/images/presentation/group-chatting.png';
import MAN_SHOWING_DIAGRAMS from '@/assets/images/presentation/man-showing-diagrams.png';
import MAN_WRITING_ICON from '@/assets/images/presentation/man-writing.png';

import { WhyReasons } from '@/components/ui/features/presentation/PresentationReviews/components/WhyReasons';

export const DetailsSection = () => {
  const { t } = useTranslation();

  return (
    <Container textAlign="center" pb={20}>
      <Flex textAlign="center" flexDirection="column" alignItems="center" maxW="800px" margin="auto">
        <Text fontFamily="heading" fontWeight="bold" fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}>
          {t('hybridEventsPage.detailsHeading.0')}
        </Text>
        <Text
          lineHeight={1}
          fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}
          fontFamily="heading"
          fontWeight="bold"
          color="violet.500"
        >
          {t('hybridEventsPage.detailsHeading.1')}
        </Text>
        <Text maxW="560px" mx="auto" mt={6}>
          {t('hybridEventsPage.detailsDescription')}
        </Text>
      </Flex>
      <Heading fontSize="3xl" mb={8} mt={12}>
        {t('hybridEventsPage.bestOfBothWorlds')}
      </Heading>
      <Flex mt={12} gap={8} flexDirection={{ base: 'column', lg: 'row' }} justifyContent="center">
        <WhyReasons
          src={MAN_WRITING_ICON}
          alt={t('hybridEventsPage.whatWeOffer.0.title')}
          title={t('hybridEventsPage.whatWeOffer.0.title')}
          description={t('hybridEventsPage.whatWeOffer.0.description')}
        />
        <WhyReasons
          src={GROUP_CHATTING_ICON}
          alt={t('hybridEventsPage.whatWeOffer.1.title')}
          title={t('hybridEventsPage.whatWeOffer.1.title')}
          description={t('hybridEventsPage.whatWeOffer.1.description')}
        />
        <WhyReasons
          src={MAN_SHOWING_DIAGRAMS}
          alt={t('hybridEventsPage.whatWeOffer.2.title')}
          title={t('hybridEventsPage.whatWeOffer.2.title')}
          description={t('hybridEventsPage.whatWeOffer.2.description')}
        />
      </Flex>
    </Container>
  );
};
